export const primaryColor = '#f47224';
export const primaryColorLight = '#f2823f';
export const primaryColorDark = '#c45b1b';
export const primaryColorStrong = `#fa6400`;
export const primaryColorWeak = `#fce8da`;

export const outlineGray = '#E8E8E8';
export const blueGray = '#344464';
export const textGrey = '#4a4b4a';

export const detailsBackground = '#f4f4fc';
export const subMenuComponentBackground = `#eef0ff`;
export const subMenuDropdownBackground = `#f6f7fe`;
export const disabledBackground = `#cccccc`;
export const disabledText = '#fffef5';

export const accentColor = '#feaaaa';
export const accentTextColor = '#ba4343';
export const green = '#2AA864';